import React, { useEffect, useState } from "react";
import "../css/wb_session_recieved_report.css";
import Export from "../Assets/images/export.png";
import Search from "../Assets/images/search.png";
import { apiCall } from "../services/authServieces";
import SearchIcon from "@mui/icons-material/Search";
import CustomDateRangePicker from "../components/CustomDatePicker";
import excelIcon from "../Assets/images/excel.png";
import { useUIContext } from "../context";
import { formatDate } from "../utils/helper";
import { ClipLoader } from "react-spinners";
import TablePagination from "@mui/material/TablePagination";
import axios from "axios";
import baseURL from "../config";


const WbSessionRecievedReport = () => {
  const [loading, setLoading] = useState(false);
  const [sessionData, getSessionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [mobilesrch, setmobilesrch] = useState('');
  const { dateRanges } = useUIContext();
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const fetchData = async (page, limit = rowsPerPage) => {
    setLoading(true);
    try {
      const dates = dateRanges?.two?.map(date => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      });
      const params = new URLSearchParams({
        mobileno: mobilesrch || undefined,
        fromDate: dates[0] || undefined,
        toDate: dates[1] || undefined,
        page: page,
        limit: limit,
      });

      const res = await apiCall({
        endpoint: `report/getSessionReportData?${params.toString()}`,
        method: "GET",
      });

      const transformedData = res.data.map(item => ({
        date: `${formatDate(item.send_date)} ${item.send_time}`,
        number: item.sender_mobile,
        label: item.sender_profile_name,
        message: item.in_msg ? item.in_msg : '',
        text: item.out_msg ? item.out_msg : ''
      }));

      getSessionData(transformedData);
      setTotalItems(res.total);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Use useEffect only for the initial render
  useEffect(() => {
    fetchData(currentPage);
  }, []); // Empty dependency array means this will only run once when the component mounts

  const handleChangePage = (event, newPage) => {
    const page = newPage + 1; // API uses 1-based indexing
    setCurrentPage(page);
    fetchData(page);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1); // Reset to first page
    fetchData(1, newRowsPerPage);
  };

  const handleSearch = () => {
    setCurrentPage(1); // Reset to the first page on search
    fetchData(1); // Fetch data for the first page
  };

  
  const handleExport = async () => {
    setLoading(true);
    try {
      const dates = dateRanges?.two?.map(date => {
        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      });
  
      // Build the query parameters
      const params = new URLSearchParams();
      if (mobilesrch) params.append('mobileno', mobilesrch);
      if (dates?.[0]) params.append('fromDate', dates[0]);
      if (dates?.[1]) params.append('toDate', dates[1]);
  
      const user = JSON.parse(localStorage.getItem("user-cred"));
      
      // Using the same approach as your working downloadExcelDashboard function
      const baseUrl =baseURL  ||  'http://localhost:8000'; // Make sure baseURL is defined
      const endpoint = `report/exportSessionReport?${params.toString()}`;
      const url = `${baseUrl}/${endpoint}`;
  
      const response = await axios.get(url, {
        responseType: 'blob',
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'Authorization': `Bearer ${user?.token}`
        }
      });
  
      // Check for empty file
      if (response.data.size === 0) {
        throw new Error('Received empty file');
      }
  
      // Generate filename
      let filename = 'session_report';
      if (dates?.[0] && dates?.[1]) {
        filename = `session_report_${dates[0]}_to_${dates[1]}`;
      }
  
      // Try to get filename from Content-Disposition header, if available
      const contentDisposition = response.headers['content-disposition'];
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
        } else {
          filename = `${filename}.xlsx`;
        }
      } else {
        filename = `${filename}.xlsx`;
      }
  
      // Create download link with the filename
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = downloadUrl;
      link.download = filename;
  
      // Append to document, click, and cleanup
      document.body.appendChild(link);
      link.click();
  
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
       ;
      }, 100);
    } catch (error) {
      console.error("Error exporting data:", error);
    
    } finally {
      setLoading(false);
    }
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <div className="Session_report_contian">
        <h4 className="Head_title MisReportTitle">
          <div className="DateRangeContain">
            <CustomDateRangePicker rangeKey="two" />
            <button type="button" className="SearchDateRange" onClick={handleSearch}>
              <img src={Search} alt="Search" />
            </button>
          </div>
          Session Report
          <div className="SessionExcelContain">
            <div className="Session_report_SearchContain">
              <input
                type="text"
                value={mobilesrch}
                onChange={(e) => setmobilesrch(e.target.value)}
                placeholder="Search"
              />
              <button type="button" onClick={handleSearch}>
                <SearchIcon />
              </button>
            </div>
            
            <button type="button" className="ExcelIconContain" onClick={handleExport}>
              <img src={excelIcon} alt="excelIcon" className="ExcelIcon"/> 
            </button>
          </div>
        </h4>
        <div className="Session_report_Card12">
         
          <div className="table_contain tableSessionR">
            <table className="Table" id="Table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Mobile</th>
                  <th>Profile Name</th>
                  <th>In Message</th>
                  <th>Out Message</th>
                </tr>
              </thead>
              <tbody>
                {sessionData.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="tableDataCenterPosition">
                      No data available
                    </td>
                  </tr>
                ) : (
                  sessionData.map((item, index) => (
                    <tr key={index}>
                      <td className="text-nowrap">{item.date}</td>
                      <td>{item.number}</td>
                      <td>{item.label.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase())}</td>
                      <td>
                        <p className="message">
                          {item.message.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase())}
                        </p>
                      </td>
                      <td>{item.text.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase())}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Material UI TablePagination like in MisReport */}
        <TablePagination
          component="div"
          count={totalItems}
          page={currentPage - 1} // MUI uses 0-based indexing
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </div>
      {loading && (
        <div className="spinnerOverlay">
          <ClipLoader loading={loading} size={50} />
        </div>
      )}
    </>
  );
};

export default WbSessionRecievedReport;